import { useAppSelector } from '@hooks/reduxHooks';
import { $api } from '@service/RequestService';
import { FlatId } from '@utils/models/Flat';
import { Pagination } from '@utils/models/Pagination';
import { useQuery } from 'react-query';

import { shaxmatkaConstants } from '..';

interface IProps {
  page?: number;
  size?: number;
  houses?: number[];
  buildings?: number[];
  rooms?: string[];
  saleStatuses?: string[];
}

export const useFlatFilterTable = (props: IProps = {}) => {
  const isFilterTabel = useAppSelector(({ userReducer: { isPermissions } }) => isPermissions?.PERMISSION_READ_FLATS);

  return useQuery<Pagination<FlatId>>({
    queryKey: [shaxmatkaConstants.queryKeys.FLAT_FILTER_TABLE, props],
    queryFn: async () => {
      const res = await $api.post('/v1/flat/filter/table', props);

      return res?.data?.data;
    },
    enabled: !!props?.buildings && isFilterTabel
  });
};
